import { Image, Pagination } from "react-bootstrap";
import Arrow_down from "../../../assests/images/arrow-left.svg";
import { PaginationWrapper } from './paginationStyle';
import { PaginationBlockProps } from '../../../utils/types';

const PaginationBlock = ({ totalPage, page, handlePre, handleNext, handlePageClick }: PaginationBlockProps) => {
  const renderPaginationItems = () => {
    let items = [];

    if (totalPage <= 5) {
      // If there are 5 or fewer pages, show all pages
      for (let i = 1; i <= totalPage; i++) {
        items.push( 
          <Pagination.Item
            key={i}
            active={i === page}
            onClick={() => handlePageClick(i)} // Pass the correct page number
          >
            {i}
          </Pagination.Item> 
        );
      }
    } else {
      // Always show the first page
      items.push(
        <Pagination.Item
          key={1}
          active={1 === page}
          onClick={() => handlePageClick(1)} // Pass the first page number
        >
          1
        </Pagination.Item>
      );

      // Show ellipsis after the first page if current page is far from it
      if (page > 3) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show two pages before the current page
      const startPage = Math.max(2, page - 1);
      const endPage = Math.min(totalPage - 1, page + 1);

      for (let i = startPage; i <= endPage; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === page}
            onClick={() => handlePageClick(i)} // Pass the correct page number
          >
            {i}
          </Pagination.Item>
        );
      }

      // Show ellipsis before the last page if current page is far from it
      if (page < totalPage - 2) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Always show the last page
      items.push(
        <Pagination.Item
          key={totalPage}
          active={totalPage === page}
          onClick={() => handlePageClick(totalPage)} // Pass the last page number
        >
          {totalPage}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div>
      <PaginationWrapper className='pagination-wrapper'>
        <Pagination>
          <Pagination.Prev className="prev-view">
            <Image src={Arrow_down} alt='Arrow_down' onClick={handlePre} />
          </Pagination.Prev>
          {renderPaginationItems()}
          <Pagination.Next className="next-view">
            <Image src={Arrow_down} alt='Arrow_down' onClick={handleNext} />
          </Pagination.Next>
        </Pagination>
      </PaginationWrapper>
    </div>
  );
};

export default PaginationBlock;